<template>
<md-card>
    <header-form title="EDITAR PERFIL" :rota="{name: 'usuarioRead'}" tooltip="Lista de Usuários" :btnHide="true" />

    <form @submit.prevent="update" autocomplete="off">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="usuario.nome" type="text" class="uppercase"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-15 md-xsmall-size-100">
                    <md-field>
                        <label>APELIDO</label>
                        <md-input v-model="usuario.apelido" type="text" class="uppercase"> </md-input>
                    </md-field>
                </div>

                <div v-if="notUsuario" class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.usuario }">
                        <label>USUARIO</label>
                        <md-input v-model="usuario.usuario" type="text" class="uppercase"> </md-input>

                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.usuario">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.usuario" class="validErro"> {{ errors.usuario[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.old_password }">
                        <label>SENHA ANTIGA</label>
                        <md-input v-model="usuario.old_password" v-focus type="password" autocomplete="off"> </md-input>

                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.old_password">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.old_password" class="validErro"> {{ errors.old_password[0] }}</div>
                </div>
                
                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.password }">
                        <label>NOVA SENHA</label>
                        <md-input v-model="usuario.password" type="password" autocomplete="off"> </md-input>

                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.password">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.password" class="validErro"> {{ errors.password[0] }}</div>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-warning md-round">
                <span class="md-label">
                    <md-icon class="material-icons">edit</md-icon>
                </span>EDITAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import Swal from "sweetalert2";

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            usuario: {},
            errors: {},
            updatePassword: this.$store.state.updatePassword,
            nivel: this.$store.state.usuario.niveis[0].id,
            notUsuario: true
        }
    },

    created() {
        if (this.nivel === 6 || this.nivel === 10) {
            this.notUsuario = false
        }
        this.getUsuario()
    },

    beforeRouteLeave(to, from, next) {
        if (to.name == 'login') {
            next();
        } else if (this.updatePassword) {
            next()
        } else {
            Swal.fire({
                title: 'ALTERE SUA SENHA',
                text: 'Por motivo de segurança, você deve alterar a sua senha.',
                customClass: {
                    confirmButton: "md-button md-danger btn-fill"
                },
                confirmButtonText: "FECHAR",
                buttonsStyling: false
            })
        }
    },

    mixins: [Notify],

    methods: {

        getUsuario() {
            this.$http.get(this.$urlAPI + 'usuarios/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.dados[0];
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        update() {
            this.$http.put(this.$urlAPI + 'usuarios/perfil/' + this.usuario.id, this.usuario)
                .then(response => {
                    if (response.data.status) {
                        this.updatePassword = true
                        this.$router.push({
                            name: 'Dashboard'
                        });
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    }
};
</script>
